import useMedia from './useMedia';

const query = {
    '(min-width: 768px)': false,
};

const useIsMobile = () => useMedia(query, true);

export default useIsMobile;
